import { Download } from 'lucide-react';
import { useState } from 'react';
import { downloadMerchantApiKeys, MerchantApiKeysExportSource } from '../../lib/merchantApiKeysExport';
import { Button } from '../ui/button';

export function MerchantApiKeysDownload({ merchant }: { merchant: MerchantApiKeysExportSource }) {
    const [error, setError] = useState<string | null>(null);
    const available = Boolean(merchant.api_key || merchant.sandbox_api_key);
    return <div className="px-6 pb-3">
        <Button type="button" variant="outline" size="sm" disabled={!available}
            onClick={() => {
                setError(null);
                try {
                    downloadMerchantApiKeys(merchant);
                } catch {
                    setError('Не удалось скачать ключи. Попробуйте ещё раз.');
                }
            }}>
            <Download className="mr-2 h-4 w-4" />
            Скачать API-ключи
        </Button>
        {!available && <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">API-ключи ещё не созданы.</p>}
        {error && <p role="alert" className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</p>}
    </div>;
}
